import type { InsertTagTypeWithOptionalGroupIdMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertTagTypeWithOptionalGroupIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type {
  CreateTagTypeRequest,
  CreateTagTypeWithOptionalGroupIdInput,
} from './types';

export const useInsertTagTypeWithOptionalGroupId = createMutationHook({
  name: 'insertTagType',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.tag.insert.mutationOptions({ onSuccess }),
  mapInput: (
    variables: CreateTagTypeWithOptionalGroupIdInput
  ): CreateTagTypeRequest => ({
    Name: variables.Name ?? '',
    Description: variables.Description ?? null,
    TagTypeGroupId: variables.TagTypeGroupId ?? null,
  }),
  invalidate: (trpc) => [trpc.frontend.tag.pathKey()],
  mapResponse: (result: {
    Id: string;
  }): InsertTagTypeWithOptionalGroupIdMutation => ({
    insert_tag_type_one: {
      __typename: 'tag_type',
      TagTypeId: result.Id,
    },
  }),
  graphqlDocument: InsertTagTypeWithOptionalGroupIdDocument,
  graphqlVariables: (variables: CreateTagTypeWithOptionalGroupIdInput) => ({
    ...variables,
  }),
  evictFields: ['tag_type'],
});
